module.exports = __webpack_public_path__ + "media/img/frontend_application/favicon-196x196-569600d25da03fbdf762e2548c3fd578.png";